/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsmessagesperchat3Inputs */

const en_statsmessagesperchat3 = /** @type {(inputs: Statsmessagesperchat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avg. per active chat`)
};

const de_statsmessagesperchat3 = /** @type {(inputs: Statsmessagesperchat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ø pro aktivem Chat`)
};

/**
* | output |
* | --- |
* | "Avg. per active chat" |
*
* @param {Statsmessagesperchat3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsmessagesperchat3 = /** @type {((inputs?: Statsmessagesperchat3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsmessagesperchat3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsmessagesperchat3(inputs)
	return de_statsmessagesperchat3(inputs)
});
export { statsmessagesperchat3 as "statsMessagesPerChat" }